import styled from 'styled-components'

const AppContainer = styled.div `
@font-face {
    font-family: 'toyota_displaybold';
    src: url(https://www.toyota.dk/fonts/notosans/NotoSans-Bold.eot);
    src: url(https://www.toyota.dk/fonts/notosans/NotoSans-Bold.eot?#iefix) format("embedded-opentype"),url(https://www.toyota.dk/fonts/notosans/NotoSans-Bold.woff) format("woff"),url(https://www.toyota.dk/fonts/notosans/NotoSans-Bold.woff) format("woff2"),url(https://www.toyota.dk/fonts/notosans/NotoSans-Bold.ttf) format("truetype"),url(https://www.toyota.dk/fonts/notosans/NotoSans-Bold.svg) format("svg");
    
    font-weight: 400;
    font-style: normal;
}

/*@font-face {
font-family: 'toyota_displayregular';
src: url(../../webfont/ToyotaDisplay_Rg-webfont.eot)
}*/
#styledbackground{
    background-size: cover;
}
@font-face {
    font-family: 'toyota_displayregular';
    src: url(https://www.toyota.dk/fonts/notosans/NotoSans.eot);
    src: url(https://www.toyota.dk/fonts/notosans/NotoSans.eot) format("embedded-opentype"),url(https://www.toyota.dk//fonts/notosans/NotoSans.woff) format("woff"),url(https://www.toyota.dk//fonts/notosans/NotoSans.woff2) format("woff2"),url(https://www.toyota.dk//fonts/notosans/NotoSans.ttf) format("truetype"),url(https://www.toyota.dk//fonts/notosans/NotoSans.svg) format("svg");
    font-style: normal
    font-weight: 400;
    font-style: normal;
}
    font-size: 16px;
    color: #333333;
    position: relative;
    font-family:toyota_displayregular, "Open Sans",Arial,Helvetica,sans-serif;
    a {
        border: none;
        padding: 0;
        margin: 0;
        text-decoration: underline;
        color: #333333;
    }
    .hide{
        display: none;
    }
    @keyframes lds-dual-ring {
        0% {
          -webkit-transform: rotate(0);
          transform: rotate(0);
        }
        100% {
          -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
        }
    }
    @-webkit-keyframes lds-dual-ring {
    0% {
        -webkit-transform: rotate(0);
        transform: rotate(0);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
    }
    .lds-css{
        width: 100%;
        height: 350px;
        text-align: center;
        position: relative;
    }
    .ringPosotion {
        
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .lds-dual-ring div {
    position: absolute;
    width: 160px;
    height: 160px;
    top: 20px;
    left: 20px;
    border-radius: 50%;
    border: 8px solid #000;
    border-color: #ff3030 transparent #ff3030 transparent;
    -webkit-animation: lds-dual-ring 1s linear infinite;
    animation: lds-dual-ring 1s linear infinite;
    }
    .lds-dual-ring {
    width: 200px !important;
    height: 200px !important;
    -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
    transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
    }
    
    background-size: cover;
    background-repeat: no-repeat;
    .up-to-date {
        margin-top: 10px;
        background-color: rgba(255, 255, 255, 0.85);
        padding: 40px 30px;
        margin: 10px auto 10px auto;
        max-width: 640px;
        text-align: left;
        position: relative;
        -webkit-transition: height, width 0.3s ease;
        transition: height, width 0.3s ease;
        box-sizing: border-box;
    }
    .center {
        text-align: center;
    }
    .top-image {
        margin: 10px 0px 20px 0px;
    }
    h2 {
        font-size: 22px;
        line-height: normal;
        padding: 10px 0px 15px 0px;
        font-weight: normal;
        margin: 0px;
    }
    .margin {
        margin-top: 30px;
    }
    * {
        box-sizing: border-box;
    }
    display: flex;
    justify-content: center;
    justify-items: center;
    flex-direction: column;
    min-height: 600px;
    background-position: center;
    form {
        opacity: 0;
        transition: 0.4s ease-in-out all;
        transform: scale(0);
        visibility: hidden;
        max-height: inherit;
        overflow: hidden;
        &.false{
            display: none;
        }
        &.show {
            opacity: 1;
            transform: scale(1);
            visibility: visible;
            display: block;
            height: auto;
        }
    }
    .hstooltip {
        content: '\e92f';
        width: 15px;
        height: 15px;
        background-size: contain;
        display: inline-block;
        .hstooltiptext {
            font-family: 'toyota_displayregular';
            font-size: 16px;
            line-height: 20px;
            visibility: hidden;
            width: 400px;
            background-color: #1b2d35;
            color: #fff;
            text-align: left;
            padding: 5px 0;
            border-radius: 6px;
            transform: translateX(-50%);
            /* Position the hstooltip text - see examples below! */
            position: absolute;
            z-index: 1;
            padding: 20px;
            a {
                color: #ffffff;
            }
        }
        &:hover {
            .hstooltiptext {
                visibility: visible;
            }
        }
    }
    @font-face {
        font-family: toyotaicons;
        src: url(https://www.toyota.dk/fonts/toyota-icon-restyle/Toyota-icon-restyle.eot);
        src: url(https://www.toyota.dk/fonts/toyota-icon-restyle/Toyota-icon-restyle.eot?#iefix)
                format('embedded-opentype'),
            url(https://www.toyota.dk/fonts/toyota-icon-restyle/Toyota-icon-restyle.woff)
                format('woff'),
            url(https://www.toyota.dk/fonts/toyota-icon-restyle/Toyota-icon-restyle.ttf)
                format('truetype'),
            url(https://www.toyota.dk/fonts/toyota-icon-restyle/Toyota-icon-restyle.svg)
                format('svg');
    }


    /* @font-face {
        font-family: "Toyota-icon-restyle";
        src: url("https://cp-common.toyota-europe.com/cp-client/fonts/toyota-icon-restyle/Toyota-icon-restyle.woff2") format("woff2"), url("https://cp-common.toyota-europe.com/cp-client/fonts/toyota-icon-restyle/Toyota-icon-restyle.woff") format("woff");
      }

      @font-face {
        font-family: "icons";
        src: url(https://cp-common.toyota-europe.com/cp-client/fonts/toyota-icon-restyle/Toyota-icon-restyle.woff2) format("woff2"), url(https://cp-common.toyota-europe.com/cp-client/fonts/toyota-icon-restyle/Toyota-icon-restyle.woff) format("woff");
        font-weight: normal;
        font-style: normal;
        font-display: block
    } */

    /* @font-face {
        font-family: "icons";
        src: url(https://www.toyota.dk/etc.clientlibs/dxp-frontend-core/clientlibs/clientlib-toyota/resources/fonts/toyota-icons.00d973d9.woff2) format("woff2");
        font-weight: normal;
        font-style: normal;
        font-display: block;
    } */
    

    /* @font-face {
        font-family: Toyota-icon-restyle;
        src: url(https://www.toyota.dk/fonts/toyota-icon-restyle/Toyota-icon-restyle.eot?nbblsh);
        src: url(https://www.toyota.dk/fonts/toyota-icon-restyle/Toyota-icon-restyle.eot?nbblsh#iefix)
                format('embedded-opentype'),
            url(https://www.toyota.dk/fonts/toyota-icon-restyle/Toyota-icon-restyle.ttf?nbblsh)
                format('truetype'),
            url(https://www.toyota.dk/fonts/toyota-icon-restyle/Toyota-icon-restyle.woff?nbblsh)
                format('woff'),
            url(https://www.toyota.dk/fonts/toyota-icon-restyle/Toyota-icon-restyle.svg?nbblsh#Toyota-icon-restyle)
                format('svg');
        font-weight: 400;
        font-style: normal;
    } */

    .icon,
    .tfs-input i[class^='icon'] {
        font-family: Toyota-icon-restyle !important;
        font-weight: 400;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        font-style: normal;
    }

    .icon-info-sign:before {
        font-family: 'icons';
        font-size: 16px;
        content: "\\e911";
    }

    #toyotaTilmeldingApp {
        height: 100%;
    }

    .topImage{
        width: 100%;
    }
    .headline{
        margin: 15px 0 0px;
        padding: 0;
        font-family: toyota_displaybold,Arial,Helvetica,sans-serif;
    }
    .headline.first{
        text-align: left;
    }
    .bodyText div{
        color: #333333;
        font-family: "toyota_displayregular", "Open Sans",Arial,Helvetica,sans-serif;
        font-size:16px;
    }
    .bodyText{
        margin-top: 15px;
        margin-bottom: 30px;
    }
    .bodyText p{
        margin: 0;
        line-height: 1.5em;
    }
    .bodyLink {
        display: inline-block;
    }
    .bodyLink a{    
        text-decoration: none;
        text-decoration: underline; 
        color: #202020;
    }
    .bodyLink a:hover{
        color: #e50000 !important;
    }
    .legalText p{
        font-size: 12px;
        text-indent: 0;
        line-height: 15px;
    }
    p{
        text-indent: 0;
    }
    .topHeaderInfomartion.hidden{
        display: none;
    }
`

export default AppContainer


// WEBPACK FOOTER //
// ./src/App-style.js